import { useEffect, useState } from "react";
import { CHANNELS } from "@/mocks/reportData";

export default function Hero() {
  const [tickerIndex, setTickerIndex] = useState(0);
  const ticker = [
    "独家：某制造企业连续三年超时排班样本调查已上线",
    "在线线索征集：你所在的小区加装电梯推进顺利吗？",
    "多位网友匿名反馈“低价游购物环节”，维权组已启动整理",
    "教育栏目：午休时间“自愿”被占用，欢迎补充线索",
  ];

  useEffect(() => {
    const t = window.setInterval(() => {
      setTickerIndex((i) => (i + 1) % ticker.length);
    }, 3800);
    return () => window.clearInterval(t);
  }, [ticker.length]);

  return (
    <section id="home" className="relative overflow-hidden bg-background-100">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-10 px-4 pb-14 pt-28 md:px-6 md:pt-32 lg:grid-cols-2 lg:pb-20">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            今日线索征集进行中
          </div>

          <h1 className="mt-5 font-display text-3xl font-black leading-snug tracking-tight text-foreground-950 md:text-[44px] md:leading-[1.2]">
            职场黑幕、社会不公，
            <br />
            只要你敢说，
            <span className="text-primary-600">我们就敢深挖</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            想爆料却找不到门路？今日爆料提供<span className="font-semibold text-foreground-900">匿名投稿</span>、
            <span className="font-semibold text-foreground-900">私信爆料</span>、<span className="font-semibold text-foreground-900">在线线索征集</span>
            多种渠道，全程保护知情人士隐私。不露名，也能让真相被看见。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <a
              href="#channels"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              立即匿名投稿
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
            <a
              href="#reports"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览深度报道
            </a>
          </div>

          <dl className="mt-9 flex flex-wrap gap-x-8 gap-y-4">
            {[
              { v: "100%", k: "匿名保障" },
              { v: "3 种", k: "安全渠道" },
              { v: "7×24h", k: "线索接收" },
            ].map((s) => (
              <div key={s.k}>
                <dt className="font-display text-2xl font-bold text-primary-600">{s.v}</dt>
                <dd className="mt-1 text-xs text-foreground-600">{s.k}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <img
            src="https://readdy.ai/api/search-image?query=a%20dramatic%20documentary%20illustration%20of%20a%20journalist%20holding%20a%20bright%20flashlight%20that%20cuts%20through%20darkness%20revealing%20hidden%20documents%20and%20shadows%2C%20investigative%20reporting%20concept%2C%20moody%20chiaroscuro%20lighting%2C%20deep%20crimson%20and%20warm%20amber%20tones%2C%20textured%20editorial%20artwork%2C%20no%20text&width=1200&height=1000&seq=hero-side-2026&orientation=squarish"
            alt="今日爆料深挖真相"
            className="h-[360px] w-full rounded-xl object-cover md:h-[460px]"
          />
          <div className="absolute -bottom-4 left-4 rounded-lg bg-background-50 px-4 py-3 shadow-soft ring-1 ring-background-200 md:left-6">
            <p className="text-xs text-foreground-500">本周征集主题</p>
            <p className="mt-1 text-sm font-semibold text-foreground-900">
              你的身边，还有哪些“说不出口”的事？
            </p>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="border-t border-background-200 bg-background-50">
        <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-3 md:px-6">
          <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
            <i className="ri-flashlight-fill text-xs" aria-hidden="true"></i>
            快讯
          </span>
          <p className="truncate text-sm text-foreground-700">{ticker[tickerIndex]}</p>
        </div>
      </div>

      {/* channels */}
      <div id="channels" className="mx-auto max-w-6xl scroll-mt-24 px-4 pb-14 pt-16 md:px-6 md:pb-16">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">LEAK CHANNELS</span>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">三种渠道，总有一种适合你</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              无论你掌握的是完整材料还是零散线索，都可以选择最稳妥的方式说出来。安全，始终是我们的第一原则。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {CHANNELS.map((c) => (
            <article
              key={c.id}
              id={c.id}
              className="scroll-mt-24 rounded-lg bg-background-50 p-6 ring-1 ring-background-200 transition-colors hover:ring-primary-300"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                <i className={`${c.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-foreground-950">{c.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              <ol className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {c.steps.map((s, i) => (
                  <li key={s} className="flex items-start gap-2 text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-[11px] font-bold text-secondary-900">
                      {i + 1}
                    </span>
                    {s}
                  </li>
                ))}
              </ol>
            </article>
          ))}
        </div>

        <div className="mt-5 flex flex-col items-center justify-between gap-4 rounded-lg bg-background-100 px-6 py-5 ring-1 ring-background-200 sm:flex-row">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-lock-2-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">对身份保护有顾虑？</p>
              <p className="text-xs text-foreground-600">先了解我们的保护指引，再决定用哪种方式。</p>
            </div>
          </div>
          <a
            href="#protect"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-secondary-500 hover:text-primary-600"
          >
            查看保护指引
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}